import {React} from "react";
import "./WordGridLarge.css"; 
import { Link } from "react-router-dom";


export default function WordGridLarge({ data, title, dictLink, onSelectItem}) {
  
  console.log("WordGrid props:", { data, title, dictLink, onSelectItem });//test log
  
  return (
      
    <div className="word-grid-container-large">
      {/* Header appears once */}
      <h2 className="grid-title-large">{title}</h2>

    <div className="grid-cards-large">
     
      {data.map((item, index) => (
       
       <Link to={item.dictLink} key={index} className="grid-card-large">
        
          <div onClick={(e) => {
          
          e.preventDefault(); // prevent navigation if only want popup
           
          onSelectItem(item);
          
          }}>
            
            <div className="korean-large">{item.korean}</div>
           
            <div className="english-large">{item.english}</div>
         
          </div>
        
        </Link>
     
     ))}
    
    </div> 
    </div>
);
}
